import React from 'react'
import './activation.css'
import SignInLink from '../user/SignInLink';

export default function ActivationError(props) {

  const { title, 
          note,
          blockers,
          supportOptions,
          userActions,
          ourActions,
          progressOptions,
        } = props.errorData;

  return (
    <div className='activationError'>
      {title                &&  <div className='actErrTitle'> {title} </div>  }
      {note                 &&  <div className='actErrInfo'>{note}</div>      }
      { blockers         &&  <div> 
                                  <div className='actErrItemTitle'>Explanation:</div>
                                  {blockers.map( blocker =>  <div className='actErrItem'> * {blocker} </div>  )}
                                  
                             </div> }

      { ourActions &&           <div>
                                  <div className='actErrItemTitle'>What we're doing about it:</div>
                                  <div >{
                                  ourActions.map(ourAction => <div className='actErrItem'>- {ourAction} </div>)
                                  }</div>
                                </div> }

      { userActions         &&  <div> 
                                  <div className='actErrItemTitle'>What can you do?</div>
                                  <div > {
                                  userActions.map(userAction => <div className='actErrItem'>- {userAction}</div>)
                                  } </div> 
                                </div> }

      { supportOptions      &&  <div> 
                                  <div className='actErrItemTitle'>Support Options:</div>
                                  <div> {supportOptions.map(supportOption => <div className='actErrItem'> - {supportOption} </div>)} </div> 
                                </div> }
      { progressOptions     &&  <div>
                                  <div className='actErrItemTitle'>Issue Progress Tracking: </div>
                                  <div>
                                    {progressOptions.map(progressOption => <div className='actErrItem'> - {progressOption}</div>)}
                                  </div>
                                </div>}
      <div>
        <SignInLink/>
      </div>

    </div>
  )
}
